import { CARD_MESSAGES } from 'core/tarjeta/constants/CardMessages';
import { GENERIC_MESSAGES } from 'shared/constants/GenericMessages';
import { ApiError } from 'shared/http';

export class SearchAccountCardTotalsError {
  message: string;

  constructor(err: ApiError) {
    switch (err.status) {
      case 400: {
        if (err.message === 'account_not_found') {
          this.message = CARD_MESSAGES.accountNotFound;
        } else if (err.message === 'invalid_account') {
          this.message = CARD_MESSAGES.accountInvalid;
        }
        break;
      }
      case 401: {
        this.message = GENERIC_MESSAGES.authenticationError;
        break;
      }
      case 403: {
        if (err.message === 'invalid_organization') {
          this.message = CARD_MESSAGES.accountNotAllowed;
        }
        break;
      }
      default: {
        this.message = GENERIC_MESSAGES.genericError;
      }
    }
  }
}
